import type { TourDefinition } from '../types';
import { TOUR_IDS } from '../types';

export const createTournamentTour: TourDefinition = {
  id: TOUR_IDS.CREATE_TOURNAMENT,
  steps: [
    {
      target: '[data-tour="create-tournament-header"]',
      titleKey: 'createTournament.welcome.title',
      contentKey: 'createTournament.welcome.content',
      placement: 'center',
      skipBeacon: true,
    },
    {
      target: '[data-tour="create-tournament-banner"]',
      titleKey: 'createTournament.banner.title',
      contentKey: 'createTournament.banner.content',
      placement: 'bottom',
    },
    {
      target: '[data-tour="create-tournament-thumbnail"]',
      titleKey: 'createTournament.thumbnail.title',
      contentKey: 'createTournament.thumbnail.content',
      placement: 'bottom',
    },
    {
      target: '[data-tour="create-tournament-basic-info-anchor"]',
      spotlightTarget: '[data-tour="create-tournament-basic-info"]',
      titleKey: 'createTournament.basicInfo.title',
      contentKey: 'createTournament.basicInfo.content',
      // Start above the card. On scroll, Floating UI flip moves it below the
      // header when there isn't room above (auto-adjust top → bottom).
      placement: 'top',
      offset: 10,
      topScrollRoom: 280,
      floatingOptions: {
        flipOptions: {
          padding: { top: 96, bottom: 16, left: 16, right: 16 },
          fallbackPlacements: ['bottom'],
        },
      },
    },
    {
      target: '[data-tour="create-tournament-game"]',
      titleKey: 'createTournament.game.title',
      contentKey: 'createTournament.game.content',
      placement: 'top',
    },
    {
      target: '[data-tour="create-tournament-settings"]',
      titleKey: 'createTournament.settings.title',
      contentKey: 'createTournament.settings.content',
      placement: 'top',
    },
    {
      target: '[data-tour="create-tournament-optional"]',
      titleKey: 'createTournament.optional.title',
      contentKey: 'createTournament.optional.content',
      placement: 'top',
    },
    {
      target: '[data-tour="create-tournament-submit"]',
      titleKey: 'createTournament.submit.title',
      contentKey: 'createTournament.submit.content',
      placement: 'top',
    },
  ],
};
